<section class="bv-vault-custom-fields tw-mb-0" [ngClass]="{ 'tw-mb-0': disableSectionMargin }">
  <h3 class="bv-vault-item-section__title">{{ "customFields" | i18n }}</h3>

  @if (!isPartialEdit && !parentFormDisabled) {
    <div class="bv-vault-custom-fields__toolbar">
      <div
        class="bv-vault-custom-fields__type-options"
        role="radiogroup"
        [attr.aria-label]="'fieldType' | i18n"
      >
        @for (option of fieldTypeOptions; track option.value) {
          <bit-form-control disableMargin class="bv-vault-custom-fields__type-option">
            <input
              bitRadio
              type="radio"
              name="customFieldType"
              [value]="option.value"
              [checked]="selectedFieldType === option.value"
              (change)="selectFieldType(option.value)"
            />
            <bit-label>{{ option.name }}</bit-label>
          </bit-form-control>
        }
      </div>
      <button
        type="button"
        bitIconButton="bwi-plus"
        class="bv-vault-custom-fields__add-btn"
        (click)="addInlineField()"
        data-testid="add-field-button"
        [label]="'addField' | i18n"
      ></button>
    </div>
  }

  @if (hasCustomFields) {
    <form [formGroup]="customFieldsForm" class="bv-vault-custom-fields__list">
      <bit-card
        formArrayName="fields"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        data-testid="custom-fields"
      >
        @for (field of fields.controls; track field; let i = $index) {
          <div
            [formGroupName]="i"
            class="bv-vault-custom-fields__row"
            [ngClass]="{
              'bv-vault-custom-fields__row--boolean': field.value.type === FieldType.Boolean,
            }"
            [attr.data-testid]="field.value.name + '-entry'"
            cdkDrag
            [cdkDragDisabled]="dragDisabled(field.value.type)"
            #customFieldRow
          >
            @if (field.value.type !== FieldType.Boolean) {
              <bit-form-field class="bv-vault-custom-fields__name" disableMargin>
                <bit-label class="tw-sr-only">{{ "fieldLabel" | i18n }}</bit-label>
                <input
                  bitInput
                  formControlName="name"
                  [attr.data-testid]="'custom-field-name-' + i"
                />
              </bit-form-field>
            }

            @if (field.value.type === FieldType.Text) {
              <bit-form-field class="bv-vault-custom-fields__value" disableMargin>
                <bit-label class="tw-sr-only">{{ "value" | i18n }}</bit-label>
                <input bitInput formControlName="value" data-testid="custom-text-field" />
              </bit-form-field>
            }

            @if (field.value.type === FieldType.Hidden) {
              <bit-form-field class="bv-vault-custom-fields__value" disableMargin>
                <bit-label class="tw-sr-only">{{ "value" | i18n }}</bit-label>
                <input
                  bitInput
                  formControlName="value"
                  type="password"
                  data-testid="custom-hidden-field"
                  class="tw-font-mono"
                />
                @if (canViewPasswords(i)) {
                  <button
                    type="button"
                    bitIconButton
                    bitSuffix
                    bitPasswordInputToggle
                    data-testid="visibility-for-custom-hidden-field"
                    (toggledChange)="logHiddenEvent($event)"
                  ></button>
                }
              </bit-form-field>
            }

            @if (field.value.type === FieldType.Boolean) {
              <bit-form-field class="bv-vault-custom-fields__name" disableMargin>
                <bit-label class="tw-sr-only">{{ "fieldLabel" | i18n }}</bit-label>
                <input
                  bitInput
                  formControlName="name"
                  [attr.data-testid]="'custom-field-name-' + i"
                />
              </bit-form-field>
              <bit-form-control
                class="bv-vault-custom-fields__value bv-vault-custom-fields__value--boolean"
                disableMargin
              >
                <input
                  bitCheckbox
                  formControlName="value"
                  type="checkbox"
                  data-testid="custom-boolean-field"
                />
                <bit-label class="tw-sr-only">{{ "value" | i18n }}</bit-label>
              </bit-form-control>
            }

            @if (field.value.type === FieldType.Linked) {
              <bit-form-field class="bv-vault-custom-fields__value" disableMargin>
                <bit-label class="tw-sr-only">{{ "value" | i18n }}</bit-label>
                <bit-select formControlName="linkedId" data-testid="custom-linked-field">
                  @for (option of linkedFieldOptions; track $index) {
                    <bit-option [value]="option.value" [label]="option.name"></bit-option>
                  }
                </bit-select>
              </bit-form-field>
            }

            @if (canEdit(field.value.type) && fields.controls.length > 1) {
              <button
                role="application"
                type="button"
                bitIconButton="bwi-drag-and-drop"
                class="bv-vault-custom-fields__action"
                cdkDragHandle
                [label]="'reorderToggleButton' | i18n: field.value.name"
                (keydown)="handleKeyDown($event, field.value.name, i)"
                data-testid="reorder-toggle-button"
                [disabled]="parentFormDisabled"
              ></button>
            }

            @if (canEdit(field.value.type)) {
              <button
                type="button"
                bitIconButton="bwi-minus-circle"
                buttonType="dangerGhost"
                class="bv-vault-custom-fields__action bv-vault-custom-fields__action--remove"
                (click)="removeFieldAt(i)"
                [label]="'remove' | i18n"
                data-testid="remove-custom-field-button"
                [disabled]="parentFormDisabled"
              ></button>
            }
          </div>
        }
      </bit-card>
    </form>
  }
</section>
